import React, { useEffect, useState } from "react";

import {
  clearAttributionParams,
  clearPersistedQueryCache,
  clearStoredFarmLocations,
  clearStoredSoilSightProjectId,
  productAnalytics,
  setLocalKlimVar,
  trackMixpanel,
  useNavigate,
  useToggleNavs,
  useTranslation,
  useUserContext,
} from "utils";

import { MainPage } from "components";

interface ShareData {
  title: string;
  summary: string;
  link: string;
  image: string;
}

export const SignOut = () => {
  const { t } = useTranslation(["signinup", "meta"]);
  const navigate = useNavigate();
  useToggleNavs(false, false);
  const { switchFarm } = useUserContext();

  const [share] = useState<ShareData>({
    title: t("meta:signOut.title"),
    summary: t("meta:signOut.description"),
    link: `${process.env.REACT_APP_FARM_URL}/sign-out`,
    image: `${process.env.REACT_APP_FARM_URL}/images/misc/share.png`,
  });

  useEffect(() => {
    setLocalKlimVar("token", null);
    setLocalKlimVar("country", null);
    clearStoredSoilSightProjectId();
    clearStoredFarmLocations();
    // We clear the attribution, so the next signup on this browser does not get the partner of the last user.
    clearAttributionParams();
    productAnalytics.reset();

    // Reset farm id, because if a different user tries to sign in, the old farm id
    // would be used leading to the backend returning 401
    switchFarm(null);

    setTimeout(() => {
      // Wiped once the user is cleared, otherwise still-mounted queries refetch it without a token (401s).
      // Torn down before navigating, so the previous user's cache cannot be restored on the next boot.
      clearPersistedQueryCache();
      navigate("/sign-in");
    }, 300);

    trackMixpanel("Logout");
  }, [navigate, switchFarm, t]);

  return (
    <MainPage pageName={"sign-in-up"} share={share} loading={true}>
      <div></div>
    </MainPage>
  );
};
